exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line-limiter[data-v-09651ef9]{max-width:979px\n}\n.configurator__price[data-v-09651ef9]{text-align:center;color:#243782;margin-top:0\n}\n.configurator__price--accent[data-v-09651ef9]{font-weight:700;color:#EF7D00\n}\n.margin-bottom-0[data-v-09651ef9]{margin-bottom:0\n}\n.flex[data-v-09651ef9]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09651ef9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/configurator/pages/SelectModel.vue
// module id = 8yJZ
// module chunks = 15